import axios from 'axios';
import { BASEURL, ENDPOINT } from './config';

const MAX_NAME = 100;
const MAX_EMAIL = 254;
const MAX_MESSAGE = 2000;

export const normalizePhone = (phone) => {
  const digits = String(phone).replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('0')) {
    return digits.slice(1);
  }

  if (digits.length === 12 && digits.startsWith('91')) {
    return digits.slice(2);
  }

  return digits;
};

export const buildAlegionContactPayload = ({
  name,
  phone,
  email_id,
  message,
  turnstile_token,
  website,
}) => {
  const payload = {
    name: String(name ?? '').trim().slice(0, MAX_NAME),
    phone: normalizePhone(phone),
    email_id: String(email_id ?? '').trim().slice(0, MAX_EMAIL),
    // Live API requires `message` even when empty; always send it.
    message: String(message ?? '').trim().slice(0, MAX_MESSAGE),
    turnstile_token: String(turnstile_token ?? '').trim(),
    // Honeypot — must stay empty for legitimate submissions.
    website: String(website ?? ''),
  };

  return payload;
};

export const createAlegionContact = async (contactData) => {
  const payload = buildAlegionContactPayload(contactData);

  const response = await axios.post(
    `${BASEURL}${ENDPOINT.CREATE_ALEGION_CONTACT}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
};

/** Normalize FastAPI / network errors into a user-facing string. */
export const getContactSubmitErrorMessage = (err) => {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  if (status === 429) {
    return 'Too many requests. Please wait a few minutes and try again.';
  }

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail) && detail.length) {
    return detail
      .map((item) => item?.msg || item?.message || JSON.stringify(item))
      .join(' ');
  }

  if (!err?.response) {
    return (
      'Could not reach the contact API. Check that the backend is running and ' +
      'REACT_APP_API_BASE_URL is correct, then try again.'
    );
  }

  return 'There was an error submitting the form. Please try again later.';
};
